import script from "./AiChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AiChat.vue?vue&type=script&setup=true&lang=js"

import "./AiChat.vue?vue&type=style&index=0&id=053b00b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053b00b8"]])

export default __exports__